import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  Box,
  CardContent,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import ScrollBar from "react-perfect-scrollbar";
import EditDelete from "../../components/EditDelete";
import Toolbar from "../../components/Toolbar";
import { useTranslation } from "react-i18next";
import { useDialog } from "../../contexts/DialogContext";
import { useNavigate, useLocation } from "react-router-dom";

import useWindowDimensions from "../../utils/windowDimensions";
// import Details from "./Details";
import { getTimeStamp } from "../../utils/common";
import Upload from "./components/Upload";
import useComplaint from "../../hooks/useComplaint";
import AdvanceFilter from "./components/AdvanceFilter";
import useMainContentDimensions from "../../utils/mainContentDimensions";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = (props) => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Complaint</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

const ComplaintClosed = (props) => {
  const { isLoadingDownload, downloadFileType } = useComplaint();
  const { width: mainContentWidth } = useMainContentDimensions();

  const { complaintId } = props;

  const currentPayload = {
    filters: [
      {
        fieldName: "complaintStatus",
        fieldValue: "CLOSED",
        op: "eq",
        dataType: "enum",
        condition: "and",
        isJoin: false,
        isEnum: true,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "customerComplaintId",
        sort: "DESC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height, width } = useWindowDimensions();
  const { getAllCustomerComplaint, customerComplaints, paging, isLoading, downloadCustomerFile } =
    useComplaint();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllCustomerComplaint(payload);
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  useEffect(() => {
    console.log(complaintId, "complaintIdcomplaintId");
  }, [complaintId]);

  useEffect(() => {
    fetchData();
  }, [payload]);

  const exportFile = async (fileType) => {
    await downloadCustomerFile(fileType, payload);
  };
  const openDownloadDialog = () => {
    return openDialog("Upload complaint", true, <Upload key={getTimeStamp()} />);
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };
  const columns = [
    {
      field: "complaintNumber",
      headerName: "Complaint No",
      width: 300,
    },
    {
      field: "radUser",
      headerName: "User Name",
      valueGetter: (params) => params?.userName,
      width: 300,
    },

    {
      field: "createdAt",
      headerName: "Complaint Date",
      width: 300,
    },
    {
      field: "complaintStatus",
      headerName: "Status",
      width: 300,
    },
    {
      field: "priority",
      headerName: "Priority",
      width: 300,
    },
    {
      field: "complaintDetails",
      headerName: "Complaint Details",
      width: 300,
    },
  ];
  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
  };

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            addPage={null}
            downloadFile={exportFile}
            openDownloadDialog={openDownloadDialog}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {t("complaint_closed")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={customerComplaints}
            getRowId={(row) => row["customerComplaintId"]}
            rowCount={paging.totalNumberOfRecords}
            loading={false}
            rowsPerPageOptions={[5]}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPageChange={(page) => onPageChange(page)}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ComplaintClosed;
